import React, { useState, useEffect } from "react";
import { Table, Space, Button, Row, Col, Input, Modal, notification, Select, Tooltip, Tag, Pagination, } from "antd";
import { EditOutlined, SearchOutlined, FilePdfOutlined, EyeOutlined, DeleteOutlined, } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { loadingPlanService } from "../../../services";
import { checkPermission } from "../../../utils/permissions";
import { useDebounce } from "../../../hooks/useDebounce";
import { changeDocumentTitle } from "../../../utils/title";
import { INVOICE_PAYMENT_STATUS } from "../../../constants";

function LoadingPlan() {

  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isModalshow, setIsModalShow] = useState(false);
  const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);
  const [loadingPlan, setLoadingPlan] = useState([]);
  const [search, setSearch] = useState(null)
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });

  const debouncedSearch = useDebounce(search, 500);

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "_id",
      render: (text, record, index) => ((pagination.current - 1) * pagination.pageSize) + index + 1
    },
    {
      title: "Invoice No",
      dataIndex: "invoice_id",
      key: "invoice_id",
      render: (text) =>
        <a
          href={`/invoice/view/${text}`}
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-primary hover:text-primary hover:underline"
        >
          {text}
        </a>

    },
    {
      title: "Container ID",
      dataIndex: "container_id",
      key: "ContainerID",
    },
    {
      title: "Container Number",
      dataIndex: "c_container_number",
      key: "ContainerNumber",
    },
    {
      title: "Booking Number",
      dataIndex: "c_booking_number",
      key: "c_booking_number",
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "Location",
      render: (text) => text.toUpperCase()
    },

    {
      title: "Actions",
      key: "Actions",
      render: (text, record, { _id }) => {
        const isPaid = record.invoice_payment_status === INVOICE_PAYMENT_STATUS.PAID;
        return (

          <Space size="small">
            {isPaid ? (
              <Tooltip title="can't edit because invoice already paid">
                <span className="text-gray-400 cursor-not-allowed">
                  <EditOutlined />
                </span>
              </Tooltip>
            ) : (
              <Link to={`/operations/loadings/edits/${record.container_id}`} className="hover:text-primary">
                <Tooltip title="Edit">
                  <EditOutlined />
                </Tooltip>
              </Link>
            )}

            < Link to={`/operations/loadings/views/${record.container_id}`} className="hover:text-primary" >
              <Tooltip title='View'>
                {/* <Button type="primary" size="small"> */}
                <EyeOutlined />
                {/* </Button> */}
              </Tooltip>
            </Link >

            {checkPermission("DELETE_LOADPLAN") && <Tooltip title='Delete'>
              {/* <Button type="primary" size="small" onClick={() => showModal(record)}> */}
              <DeleteOutlined onClick={() => showModal(record)} />
              {/* </Button> */}
            </Tooltip>}
            {
              record.have_Pdf ?
                <Link>
                  <Tag color="default" style={{ cursor: "pointer" }} onClick={() => window.open(`/operations/loadings/pdf/${record.container_id}`)}>
                    View PDF
                  </Tag>
                </Link> : <Link to={`/operations/loadings/generates-plans/${record.container_id}`} >
                  <Tooltip title='Pdf'>
                    <Button type="default" size="small">
                      <FilePdfOutlined />
                    </Button>
                  </Tooltip>
                </Link>
            }

            {
              (record.pull_out_date != "0000-00-00" && record.bookingCount === 0) &&
              <Link to={`/operations/bl-forms/add/${record.c_booking_number}`}>
                <Button type="default" size="small">
                  Doc Receipt
                </Button>
              </Link>
            }
            {(record.bookingCount > 0) && <Tag color="default">Dock Receipt Generated</Tag>}
          </Space >
        )

      },
    },
  ];

  const showModal = (record) => {
    setSelectedDeleteRecord(record);
    setIsModalShow(true);
  };

  const handleCancel = () => {
    setIsModalShow(false);
    setSelectedDeleteRecord(null);
  };

  const handleDelete = async () => {
    if (!selectedDeleteRecord || !selectedDeleteRecord.container_id) {
      console.error("No entry selected for deletion.");
      return;
    }
    setDeleteLoading(true)
    const response = await loadingPlanService.deletePlan(
      selectedDeleteRecord.container_id
    );
    setDeleteLoading(false)
    if (response.success) {
      notification.success({
        message: "Delete Successfully!",
        description: response.message,
        placement: "topRight",
      });
      initialize(pagination.current, pagination.pageSize);
    } else {
      console.error("Failed to delete the customer.");
    }
    setIsModalShow(false);
  };

  const initialize = async (page = 1, pageSize = pagination.current) => {
    try {
      setLoading(true);

      const { success, data, message } = await loadingPlanService.fetchloaded(
        page,
        pageSize,
        debouncedSearch
      );

      if (success) {
        if (data && data.data && data.data.length > 0) {
          setLoadingPlan(data.data);
          setPagination((prev) => ({
            ...prev,
            total: data.total,
            current: page,
            pageSize,
          }));
        } else {
          console.warn("No loading plan data found.");
          setLoadingPlan([]);
        }
      } else {
        console.error(
          `Error: ${message || "Failed to fetch loading plan data."}`
        );
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    changeDocumentTitle("Load Plans");
    initialize(pagination.current, pagination.pageSize);
  }, [debouncedSearch]);

  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <div className="flex justify-between items-center">
        <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">
          Loaded Containers
        </h1>
        <Input
          placeholder="Search by Container id & Container no"
          prefix={<SearchOutlined />}
          style={{
            width: "33%",
            borderRadius: "20px",
            fontSize: 14,
            margin: 10
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>


      <Table
        columns={columns}
        scroll={{ x: "max-content" }}
        dataSource={loadingPlan}
        rowKey="container_id"
        style={{ marginTop: "10px" }}
        loading={loading}
        // pagination={{
        //   current: pagination.current,
        //   total: pagination.total,
        //   pageSize: pagination.pageSize,
        //   onChange: (page) => initialize(page, pagination.pageSize),
        //   showSizeChanger: false,
        // }}
        pagination={false}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize, search)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />

      {/* delete modal */}
      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={isModalshow}
        onOk={handleDelete}
        onCancel={handleCancel}
        centered
        styles={{
          body: {
            padding: "20px",
          },
        }}
        width={300}
        footer={
          <div className="flex justify-center gap-3">
            <Button
              type="default"
              onClick={handleCancel}
              style={{ width: "30%" }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleDelete}
              loading={deleteLoading}
              style={{ width: "30%" }}
            >
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: "center" }}>
          Are you sure you want to delete this?
        </p>
      </Modal>
    </div>
  );
}
export default LoadingPlan;
